var map = {
	"./core/Drawer/Drawer.vue": 1019,
	"./core/Drawer/DrawerLinks.vue": 70135,
	"./core/Drawer/LogoSection.vue": 63833,
	"./core/Drawer/ModuleLinks.vue": 73436,
	"./core/NestedField.vue": 29077,
	"./core/PlatformProgress.vue": 79312,
	"./core/Toolbar.vue": 72451,
	"./core/View.vue": 97757,
	"./core/ViewAuth.vue": 9175,
	"./core/ViewWidget.vue": 25573,
	"./core/Warnings.vue": 34074,
	"./helper/AddPhone.vue": 52935,
	"./helper/ConfirmDialog.vue": 64138,
	"./helper/Cropper.vue": 71453,
	"./helper/DepositFunds.vue": 49961,
	"./helper/FillProfile.vue": 35898,
	"./helper/IconCustom.vue": 21213,
	"./helper/Loading.vue": 2221,
	"./helper/MaintenanceMode.vue": 13117,
	"./helper/Notification.vue": 65242,
	"./helper/Offset.vue": 13018,
	"./helper/PermissionDialog.vue": 90567,
	"./helper/StartWhiteLabel.vue": 85806,
	"./helper/SuccessAnimation.vue": 52630,
	"./helper/Suspended.vue": 50128,
	"./helper/UModal.vue": 45670,
	"./helper/UploadImages.vue": 53742,
	"./helper/VersionDialog.vue": 48057,
	"./icons/IconBotManager.vue": 86725,
	"./icons/IconBots.vue": 43199,
	"./icons/IconBtc.vue": 31840,
	"./icons/IconCalc.vue": 36587,
	"./icons/IconCompany.vue": 13698,
	"./icons/IconDashboard.vue": 76450,
	"./icons/IconInvoice.vue": 99189,
	"./icons/IconLabel.vue": 51823,
	"./icons/IconLinked.vue": 51209,
	"./icons/IconMyBots.vue": 69173,
	"./icons/IconPortfolio.vue": 91758,
	"./icons/IconProduct.vue": 14287,
	"./icons/IconProject.vue": 16347,
	"./icons/IconRating.vue": 20306,
	"./icons/IconUser.vue": 80539,
	"./icons/IconWallet.vue": 85793,
	"./ui-2/Checkbox.vue": 40646,
	"./ui-2/Products.vue": 94929,
	"./ui-2/Select.vue": 63494,
	"./ui-2/Text.vue": 45712,
	"./ui-2/Textarea.vue": 42391,
	"./ui/Checkbox.vue": 92852,
	"./ui/Products.vue": 1503,
	"./ui/Select.vue": 32277,
	"./ui/Text.vue": 9974,
	"./ui/Textarea.vue": 1518
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 23808;